import { useState } from 'react';

const SUPABASE_URL      = 'https://zgkggkmzrlipmvtmoytn.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpna2dna216cmxpcG12dG1veXRuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgwNDk3ODcsImV4cCI6MjA5MzYyNTc4N30.ASrXEfhOx6s-yrU_QWen9OK7EaIhrYRpxhJMZZwfHKw';

const SOCIAL_WORKERS = [
  { ar: 'روان ابو الوفا',    en: 'Rawan Abu Al-Wafa' },
  { ar: 'مجدولين النعيمات', en: 'Majdolin Al-Nuaimat' },
  { ar: 'نانسي الشطي',       en: 'Nancy Al-Shati' },
  { ar: 'أمال الحجاج',       en: 'Amal Al-Hajjaj' },
  { ar: 'هديل الجبور',       en: 'Hadeel Al-Jbour' },
  { ar: 'تمارا الوريدات',    en: 'Tamara Al-Waridat' },
  { ar: 'آلاء أبو علي',      en: 'Alaa Abu Ali' },
  { ar: 'رحمة أهرام',        en: 'Rahma Ahram' },
  { ar: 'سلمان عامر',        en: 'Salman Amer' },
  { ar: 'مي عبيني',          en: 'May Ubaini' },
];

const REFERRING_SERVICES = ['Palliative','Medical','Surgical','ER','Pediatric','BMT-Adult','BMT-Ped','Leukemia','Other'];

const PHQ4_OPTIONS = [
  { value: 0, ar: 'أبداً',                  en: 'Not at all' },
  { value: 1, ar: 'عدة أيام',               en: 'Several days' },
  { value: 2, ar: 'أكثر من نصف الأيام',     en: 'More than half the days' },
  { value: 3, ar: 'كل يوم تقريباً',         en: 'Nearly every day' },
];

const PHQ4_QUESTIONS = [
  { id:'phq1', ar:'الشعور بالتوتر أو القلق أو الانزعاج',           en:'Feeling nervous, anxious or on edge' },
  { id:'phq2', ar:'عدم القدرة على إيقاف القلق أو السيطرة عليه',    en:'Not being able to stop or control worrying' },
  { id:'phq3', ar:'الشعور بالإحباط أو الاكتئاب أو اليأس',          en:'Feeling down, depressed or hopeless' },
  { id:'phq4', ar:'ضعف الاهتمام أو الاستمتاع بالأشياء',            en:'Little interest or pleasure in doing things' },
];

// Arabic wording below is taken verbatim from the final KHCC Arabic NCCN DT-PL instrument
// (Appendix C, Round 2 Reconciliation). \u2066 / \u2069 keep "0-10" displaying
// left-to-right inside right-to-left text.
const DT_TITLE_AR       = 'مقياس الضيق (كدر) — NCCN';
const DT_DEFINITION_AR  = 'الضيق هو مُعاناة ذات طبيعة نفسية، أو جسمانية، أو اجتماعية، أو روحانية. قد تؤثر على طريقة تفكيرك أو شعورك أو تصرفك. الضيق (الكدر) قد يجعل التعايش مع السرطان، أعراضه أو علاجه أكثر صعوبة.';
const DT_DEFINITION_EN  = 'Distress is an unpleasant experience of a mental, physical, social, or spiritual nature. It can affect the way you think, feel, or act. Distress may make it harder to cope with having cancer, its symptoms, or its treatment.';
const DT_INSTRUCTION_AR = 'التعليمات: يُرجى وضع دائرة حول الرقم (\u20660-10\u2069) الذي يصف بشكلٍ أفضل مقدار الضيق الذي عانيته في الأسبوع الماضي، بما في ذلك اليوم.';
const DT_TOP_AR         = 'ضيق شديد جدا';
const DT_BOTTOM_AR      = 'لا يوجد ضيق';

const PROBLEM_CATEGORIES = [
  {
    id:'physical', ar:'مخاوف جسمانية', en:'Physical Concerns', color:'#2E7D6B',
    problems:[
      { id:'pain',         ar:'الألم',                               en:'Pain' },
      { id:'sleep',        ar:'النوم',                               en:'Sleep' },
      { id:'fatigue',      ar:'الإرهاق',                             en:'Fatigue' },
      { id:'smoking',      ar:'استخدام التبغ',                       en:'Tobacco use' },
      { id:'substance',    ar:'تعاطي المواد المُخدرة',               en:'Substance use' },
      { id:'memory',       ar:'الذاكرة أو التركيز',                  en:'Memory/Concentration' },
      { id:'sexual',       ar:'الصحة الجنسية',                       en:'Sexual health' },
      { id:'eating',       ar:'تغيرات في الأكل',                     en:'Changes in eating' },
      { id:'physical_loss',ar:'فقدان أو تغيّر القدرات الجسمانية',    en:'Loss/change of physical abilities' },
    ],
  },
  {
    id:'emotional', ar:'مخاوف عاطفية', en:'Emotional Concerns', color:'#8E44AD',
    problems:[
      { id:'anxiety',    ar:'الهم أو القلق',                                                en:'Worry or anxiety' },
      { id:'sadness',    ar:'الحزن أو الاكتئاب',                                            en:'Sadness or depression' },
      { id:'interest',   ar:'فقدان الاهتمام أو المتعة',                                     en:'Loss of interest/enjoyment' },
      { id:'grief',      ar:'الحزن الشديد أو الفقدان',                                      en:'Grief or loss' },
      { id:'fear',       ar:'الخوف',                                                         en:'Fears' },
      { id:'lonely',     ar:'الوحدة',                                                        en:'Loneliness' },
      { id:'anger',      ar:'الغضب',                                                         en:'Anger' },
      { id:'appearance', ar:'التغيرات في المظهر',                                           en:'Changes in appearance' },
      { id:'worthless',  ar:'الشعور بانعدام القيمة أو بأنك تشكل عبئًا على الآخرين',        en:'Feeling of worthlessness or being a burden' },
    ],
  },
  {
    id:'social', ar:'مخاوف اجتماعية', en:'Social Concerns', color:'#C8956C',
    problems:[
      { id:'partner',    ar:'العلاقة مع الزوج/الزوجة أو الشريك/الشريكة', en:'Relationship with spouse/partner' },
      { id:'children',   ar:'العلاقة مع الأبناء',                         en:'Relationship with children' },
      { id:'family',     ar:'العلاقة مع أفراد الأسرة',                    en:'Relationship with family' },
      { id:'friends',    ar:'العلاقة مع الأصدقاء أو زملاء العمل',         en:'Relationship with friends/coworkers' },
      { id:'healthcare', ar:'التواصل مع فريق الرعاية الصحية',             en:'Communication with health care team' },
      { id:'fertility',  ar:'القُدرة على الإنجاب',                        en:'Ability to have children' },
      { id:'discrimination', ar:'التعصب أو التمييز',                     en:'Prejudice or discrimination' },
    ],
  },
  {
    id:'practical', ar:'مخاوف عملية', en:'Practical Problems', color:'#2980B9',
    problems:[
      { id:'self_care',  ar:'العناية بنفسي',                      en:'Taking care of myself' },
      { id:'caregiving', ar:'العناية بالآخرين',                   en:'Taking care of others' },
      { id:'safety',     ar:'الأمان/السلامة',                      en:'Safety' },
      { id:'work',       ar:'العمل',                               en:'Work' },
      { id:'school',     ar:'الدراسة',                             en:'School' },
      { id:'housing',    ar:'السكن/المرافق',                               en:'Housing' },
      { id:'financial',  ar:'الأمور المالية',                      en:'Finances' },
      { id:'insurance',  ar:'التأمين الصحي',                       en:'Insurance' },
      { id:'transport',  ar:'المواصلات',                           en:'Transportation' },
      { id:'childcare',  ar:'رعاية الأطفال',                      en:'Child care' },
      { id:'food',       ar:'توفر طعام كافٍ',                      en:'Having enough food' },
      { id:'medication', ar:'الحصول على أدوية',                   en:'Access to medicine' },
      { id:'treatment',  ar:'قرارات العلاج',                       en:'Treatment decisions' },
    ],
  },
  {
    id:'spiritual', ar:'مخاوف روحانية أو دينية', en:'Spiritual/Religious Concerns', color:'#D4930A',
    problems:[
      { id:'meaning',  ar:'احساس بمعنى أو هدف للحياة',                              en:'Sense of meaning or purpose' },
      { id:'beliefs',  ar:'تغيرات في الإيمان أو المعتقدات',                         en:'Changes in faith or beliefs' },
      { id:'death',    ar:'الوفاة، ما قبل الوفاة، أو الحياة الآخرة',                 en:'Death, dying or afterlife' },
      { id:'conflict', ar:'التعارض بين المعتقدات الروحانية وعلاجات السرطان',        en:'Conflict between beliefs and cancer treatments' },
      { id:'sacred',   ar:'العلاقة بالمقدّس',                                       en:'Relationship with God' },
      { id:'rituals',  ar:'احتياجات متعلقة بالشعائر الدينية أو احتياجات غذائية',   en:'Ritual or dietary' },
    ],
  },
  {
    id:'other_concerns', ar:'مخاوف أخرى', en:'Other Concerns', color:'#7F8C8D',
    problems:[
      { id:'abuse',    ar:'الإساءة أو الإهمال',                   en:'Abuse or neglect' },
      { id:'suicidal', ar:'أفكار أو محاولات إيذاء النفس',        en:'Suicidal ideation or attempt' },
    ],
  },
];

// ── Thermometer ───────────────────────────────────────────────────
function Thermometer({ value, onChange, topLabel, bottomLabel }) {
  const levels   = [10,9,8,7,6,5,4,3,2,1,0];
  const getColor = (v) => v >= 8 ? '#C0392B' : v >= 5 ? '#D4930A' : v >= 3 ? '#E8B84B' : '#2E7D6B';
  return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center' }}>
      {topLabel && <div style={{ fontSize:11, fontWeight:700, color:'#C0392B', textAlign:'center', maxWidth:96, marginBottom:8, lineHeight:1.4 }}>{topLabel}</div>}
      <div style={{ width:52, height:52, borderRadius:'50%', background:value!==null?getColor(value):'#E0DDD8', border:'3px solid #ccc', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, fontWeight:700, color:'#fff', marginBottom:-4, zIndex:2, transition:'background 0.3s', boxShadow:'0 2px 8px rgba(0,0,0,0.15)' }}>
        {value !== null ? value : '?'}
      </div>
      <div style={{ border:'3px solid #ccc', borderRadius:8, overflow:'hidden', width:60 }}>
        {levels.map(n => {
          const isBel = value !== null && n <= value;
          const col   = getColor(n);
          return (
            <button key={n} onClick={() => onChange(n)}
              style={{ height:36, width:'100%', border:'none', borderBottom:'1px solid rgba(0,0,0,0.08)', background:isBel?col:'#F5F5F5', color:isBel?'#fff':'#666', fontSize:14, fontWeight:700, cursor:'pointer', transition:'all 0.12s', display:'flex', alignItems:'center', justifyContent:'center' }}>
              {n}
            </button>
          );
        })}
      </div>
      {bottomLabel && <div style={{ fontSize:11, fontWeight:700, color:'#2E7D6B', textAlign:'center', maxWidth:96, marginTop:8, lineHeight:1.4 }}>{bottomLabel}</div>}
    </div>
  );
}

// ── Submit ────────────────────────────────────────────────────────
async function submitForm(payload) {
  const res = await fetch(`${SUPABASE_URL}/functions/v1/send-dts-email`, {
    method:'POST',
    headers:{ 'Content-Type':'application/json', 'Authorization':`Bearer ${SUPABASE_ANON_KEY}` },
    body: JSON.stringify(payload),
  });
  const text = await res.text();
  console.log('DTS:', res.status, text);
  try {
    const data = JSON.parse(text);
    if (!data.ok) throw new Error(data.error || text);
    return true;
  } catch(e) { throw new Error(`HTTP ${res.status}: ${text}`); }
}

// ── Main ──────────────────────────────────────────────────────────
export default function DTSForm() {
  const [lang, setLang]           = useState('ar');
  const [mrn, setMrn]             = useState('');
  const [date, setDate]           = useState(new Date().toISOString().split('T')[0]);
  const [setting, setSetting]     = useState('Inpatient');
  const [refService, setRefService] = useState('Palliative');
  const [socialWorker, setSocialWorker] = useState('');
  const [distress, setDistress]   = useState(null);
  const [checked, setChecked]     = useState({});
  const [otherConcern, setOtherConcern] = useState('');
  const [needsAnything, setNeedsAnything] = useState('');
  const [needsToday, setNeedsToday]       = useState('');
  const [phq4, setPhq4]           = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError]         = useState('');
  const isAr = lang === 'ar';

  const toggleCheck = (id) => setChecked(prev => ({ ...prev, [id]: !prev[id] }));
  const phq4Total   = PHQ4_QUESTIONS.reduce((s,q) => s + (phq4[q.id] ?? 0), 0);
  const phq4Done    = PHQ4_QUESTIONS.every(q => phq4[q.id] !== undefined);

  const handleSubmit = async () => {
    if (!mrn.trim())       { setError(isAr?'الرجاء إدخال رقم الملف الطبي':'Please enter MRN'); return; }
    if (!socialWorker)     { setError(isAr?'الرجاء اختيار الأخصائي الاجتماعي':'Please select a social worker'); return; }
    if (distress === null) { setError(isAr?'الرجاء تحديد مستوى الضيق':'Please select your distress level'); return; }
    if (!phq4Done)         { setError(isAr?'الرجاء الإجابة على جميع أسئلة PHQ-4':'Please answer all PHQ-4 questions'); return; }
    setError(''); setSubmitting(true);
    try {
      await submitForm({ mrn, date, setting, refService, socialWorker, distress, checked, otherConcern, needsAnything, needsToday, phq4, phq4Total });
      setSubmitted(true);
    } catch(e) {
      console.error(e);
      setError(`Error: ${e?.message || 'Unknown error'}`);
    }
    setSubmitting(false);
  };

  // ── THANK YOU ─────────────────────────────────────────────────
  if (submitted) return (
    <div style={{ minHeight:'100vh', background:'#F5EFE6', display:'flex', alignItems:'center', justifyContent:'center', padding:20, fontFamily:'Arial,sans-serif' }}>
      <div style={{ background:'#fff', borderRadius:16, padding:36, maxWidth:460, width:'100%', boxShadow:'0 4px 24px rgba(0,0,0,0.10)', textAlign:'center' }}>
        <div style={{ fontSize:56, marginBottom:14 }}>✅</div>
        <div style={{ fontSize:22, fontWeight:700, color:'#2E7D6B', marginBottom:6 }}>شكراً لك</div>
        <div style={{ fontSize:18, fontWeight:600, color:'#3D4F5C', marginBottom:14 }}>Thank You</div>
        <div style={{ fontSize:13, color:'#666', lineHeight:1.9, marginBottom:20 }}>
          تم إرسال إجاباتك إلى الأخصائي الاجتماعي المعني.<br/>
          Your responses have been sent to your assigned social worker.
        </div>
        <div style={{ background:'#F5EFE6', borderRadius:10, padding:'12px 16px', fontSize:12, color:'#888' }}>
          King Hussein Cancer Center · Psycho-Oncology Program
        </div>
      </div>
    </div>
  );

  // ── FORM ──────────────────────────────────────────────────────
  return (
    <div style={{ minHeight:'100vh', background:'#F5EFE6', fontFamily:'Arial,sans-serif' }} dir={isAr?'rtl':'ltr'}>

      {/* Header */}
      <div style={{ background:'#3D4F5C', borderBottom:'4px solid #C8956C' }}>
        <div style={{ maxWidth:800, margin:'0 auto', padding:'14px 18px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div>
            <div style={{ color:'#C8956C', fontSize:13, fontWeight:700, letterSpacing:'0.5px' }}>KING HUSSEIN CANCER CENTER</div>
            <div style={{ color:'rgba(245,239,230,0.75)', fontSize:12, marginTop:2 }}>{isAr?'برنامج أورام الطب النفسي':'Psycho-Oncology Program'}</div>
          </div>
          <div style={{ display:'flex', background:'rgba(255,255,255,0.1)', borderRadius:8, overflow:'hidden' }}>
            <button onClick={() => setLang('ar')} style={{ padding:'7px 14px', border:'none', background:isAr?'#C8956C':'transparent', color:isAr?'#fff':'rgba(245,239,230,0.65)', fontSize:13, fontWeight:600, cursor:'pointer' }}>عربي</button>
            <button onClick={() => setLang('en')} style={{ padding:'7px 14px', border:'none', background:!isAr?'#C8956C':'transparent', color:!isAr?'#fff':'rgba(245,239,230,0.65)', fontSize:13, fontWeight:600, cursor:'pointer' }}>English</button>
          </div>
        </div>
      </div>

      <div style={{ maxWidth:800, margin:'0 auto', padding:'18px 16px 80px' }}>

        {/* Title */}
        <div style={{ background:'#fff', borderRadius:14, padding:'18px 20px', marginBottom:14, boxShadow:'0 2px 12px rgba(60,50,40,0.09)', border:'1px solid rgba(200,149,108,0.18)' }}>
          <div style={{ fontSize:20, fontWeight:700, color:'#3D4F5C', marginBottom:3 }}>{isAr?DT_TITLE_AR:'Distress Thermometer Scale'}</div>
          <div style={{ fontSize:13, color:'#C8956C', fontWeight:600, marginBottom:10 }}>DTS · Psycho-Oncology Program</div>
          <div style={{ fontSize:13, color:'#555', lineHeight:1.7, padding:'10px 14px', background:'#F5EFE6', borderRadius:8 }}>
            {isAr?'يرجى الإجابة على الأسئلة التالية بصدق. ستساعدنا إجاباتك في تقديم الدعم المناسب لك.':'Please answer the following questions honestly. Your answers will help us provide you with the appropriate support.'}
          </div>
        </div>

        {/* Patient Info */}
        <div style={{ background:'#fff', borderRadius:14, padding:'18px 20px', marginBottom:14, boxShadow:'0 2px 12px rgba(60,50,40,0.09)', border:'1px solid rgba(200,149,108,0.18)' }}>
          <div style={{ fontSize:14, fontWeight:700, color:'#3D4F5C', marginBottom:14 }}>{isAr?'معلومات المريض':'Patient Information'}</div>

          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:12 }}>
            <div>
              <label style={ls.label}>{isAr?'رقم الملف الطبي (MRN)':'Medical Record No. (MRN)'}</label>
              <input style={ls.input} placeholder={isAr?'أدخل رقم الملف':'Enter MRN'} value={mrn} onChange={e => setMrn(e.target.value)} />
            </div>
            <div>
              <label style={ls.label}>{isAr?'التاريخ':'Date'}</label>
              <input style={ls.input} type="date" value={date} onChange={e => setDate(e.target.value)} />
            </div>
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:12 }}>
            <div>
              <label style={ls.label}>Setting</label>
              <select style={ls.input} value={setting} onChange={e => setSetting(e.target.value)}>
                <option value="Inpatient">Inpatient</option>
                <option value="Outpatient">Outpatient</option>
              </select>
            </div>
            <div>
              <label style={ls.label}>Referred from Service</label>
              <select style={ls.input} value={refService} onChange={e => setRefService(e.target.value)}>
                {REFERRING_SERVICES.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
          </div>

          <div>
            <label style={ls.label}>{isAr?'الأخصائي الاجتماعي المعني':'Assigned Social Worker'}</label>
            <select style={ls.input} value={socialWorker} onChange={e => setSocialWorker(e.target.value)}>
              <option value="">{isAr?'— اختر الأخصائي الاجتماعي —':'— Select Social Worker —'}</option>
              {SOCIAL_WORKERS.map(sw => <option key={sw.ar} value={sw.en}>{isAr ? sw.ar : `${sw.en} / ${sw.ar}`}</option>)}
            </select>
          </div>
        </div>

        {/* Distress Thermometer */}
        <div style={{ background:'#fff', borderRadius:14, padding:'18px 20px', marginBottom:14, boxShadow:'0 2px 12px rgba(60,50,40,0.09)', border:'1px solid rgba(200,149,108,0.18)' }}>
          <div style={{ fontSize:15, fontWeight:700, color:'#3D4F5C', marginBottom:4 }}>{isAr?'مقياس الضيق (٠–١٠)':'Distress Thermometer (0–10)'}</div>
          <div style={{ fontSize:12, color:'#555', marginBottom:10, lineHeight:1.8, padding:'10px 14px', background:'#F5EFE6', borderRadius:8 }}>
            {isAr ? DT_DEFINITION_AR : DT_DEFINITION_EN}
          </div>
          <div style={{ fontSize:12, color:'#888', marginBottom:16, lineHeight:1.7 }}>
            {isAr
              ? DT_INSTRUCTION_AR
              : 'How much distress have you been experiencing in the past week including today? (0 = No distress, 10 = Extreme distress)'}
          </div>
          <div style={{ display:'flex', gap:24, alignItems:'flex-start', flexWrap:'wrap' }}>
            <Thermometer value={distress} onChange={setDistress} topLabel={isAr?DT_TOP_AR:'Extreme distress'} bottomLabel={isAr?DT_BOTTOM_AR:'No distress'} />
            <div style={{ flex:1, minWidth:220 }}>
              {[
                { range:'8–10', color:'#C0392B', ar:'ضيق شديد جداً',       en:'Extreme distress' },
                { range:'5–7',  color:'#D4930A', ar:'ضيق متوسط إلى شديد', en:'Moderate to severe distress' },
                { range:'3–4',  color:'#E8B84B', ar:'ضيق خفيف إلى متوسط', en:'Mild to moderate distress' },
                { range:'0–2',  color:'#2E7D6B', ar:'ضيق خفيف أو لا يوجد',en:'Little or no distress' },
              ].map(l => (
                <div key={l.range} style={{ display:'flex', alignItems:'center', gap:10, marginBottom:8 }}>
                  <div style={{ width:30, height:18, borderRadius:4, background:l.color, flexShrink:0 }}/>
                  <div style={{ fontSize:12, color:'#555' }}>
                    <span style={{ fontWeight:700, color:l.color }}>{l.range}</span>{' — '}{isAr?l.ar:l.en}
                  </div>
                </div>
              ))}
              {distress !== null && (
                <div style={{ marginTop:12, padding:'10px 14px', background:'#F5EFE6', borderRadius:8 }}>
                  <span style={{ fontSize:14, fontWeight:700, color:'#3D4F5C' }}>
                    {isAr?`المستوى المختار: ${distress}/١٠`:`Selected: ${distress}/10`}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Problem List */}
        <div style={{ background:'#fff', borderRadius:14, padding:'18px 20px', marginBottom:14, boxShadow:'0 2px 12px rgba(60,50,40,0.09)', border:'1px solid rgba(200,149,108,0.18)' }}>
          <div style={{ fontSize:15, fontWeight:700, color:'#3D4F5C', marginBottom:4 }}>{isAr?'قائمة المشاكل':'Problem List'}</div>
          <div style={{ fontSize:12, color:'#888', marginBottom:16 }}>
            {isAr?'هل كان لديك مخاوف حول أي من الأمور التالية في الأسبوع الماضي، بما في ذلك اليوم؟ (ضع إشارة على جميع ما ينطبق عليك)':'Please check any problems you have been experiencing in the past week'}
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(300px,1fr))', gap:12 }}>
            {PROBLEM_CATEGORIES.map(cat => (
              <div key={cat.id} style={{ border:`1.5px solid ${cat.color}33`, borderRadius:10, overflow:'hidden' }}>
                <div style={{ background:cat.color, padding:'8px 14px' }}>
                  <div style={{ fontSize:13, fontWeight:700, color:'#fff' }}>{isAr?cat.ar:cat.en}</div>
                </div>
                <div style={{ padding:'8px 12px', display:'flex', flexDirection:'column', gap:4 }}>
                  {cat.problems.map(p => (
                    <label key={p.id} style={{ display:'flex', alignItems:'center', gap:10, cursor:'pointer', padding:'5px 6px', borderRadius:6, background:checked[p.id]?`${cat.color}14`:'transparent' }}>
                      <input type="checkbox" checked={!!checked[p.id]} onChange={() => toggleCheck(p.id)}
                        style={{ width:16, height:16, accentColor:cat.color, cursor:'pointer', flexShrink:0 }} />
                      <span style={{ fontSize:13, color:checked[p.id]?cat.color:'#333', fontWeight:checked[p.id]?600:400 }}>
                        {isAr?p.ar:p.en}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Other free text */}
          <div style={{ marginTop:12, padding:'14px', background:'#F5EFE6', borderRadius:10 }}>
            <label style={ls.label}>{isAr?'مخاوف أخرى (اختياري)':'Other Concerns (optional)'}</label>
            <input style={ls.input} placeholder={isAr?'اذكر أي مخاوف أخرى...':'Describe any other concerns...'} value={otherConcern} onChange={e => setOtherConcern(e.target.value)} />
          </div>
        </div>

        {/* Optional patient questions */}
        <div style={{ background:'#fff', borderRadius:14, padding:'18px 20px', marginBottom:14, boxShadow:'0 2px 12px rgba(60,50,40,0.09)', border:'1px solid rgba(200,149,108,0.18)' }}>
          <div style={{ fontSize:15, fontWeight:700, color:'#3D4F5C', marginBottom:4 }}>
            {isAr?'أسئلة إضافية (اختياري)':'Additional Questions (optional)'}
          </div>
          <div style={{ fontSize:12, color:'#888', marginBottom:16 }}>
            {isAr?'يمكنك الإجابة على هذه الأسئلة إن أردت':'You may answer these questions if you wish'}
          </div>
          <div style={{ marginBottom:14 }}>
            <label style={ls.label}>{isAr?'هل تحتاج إلى شيء آخر؟':'Is there anything else you need?'}</label>
            <input style={ls.input} placeholder={isAr?'اكتب هنا...':'Write here...'} value={needsAnything} onChange={e => setNeedsAnything(e.target.value)} />
          </div>
          <div>
            <label style={ls.label}>{isAr?'ماذا تحتاج منا اليوم؟':'What do you need from us today?'}</label>
            <input style={ls.input} placeholder={isAr?'اكتب هنا...':'Write here...'} value={needsToday} onChange={e => setNeedsToday(e.target.value)} />
          </div>
        </div>

        {/* PHQ-4 */}
        <div style={{ background:'#fff', borderRadius:14, padding:'18px 20px', marginBottom:14, boxShadow:'0 2px 12px rgba(60,50,40,0.09)', border:'1px solid rgba(100,100,200,0.2)' }}>
          <div style={{ fontSize:15, fontWeight:700, color:'#3D4F5C', marginBottom:4 }}>
            {isAr?'استبيان الصحة النفسية (PHQ-4)':'Patient Health Questionnaire (PHQ-4)'}
          </div>
          <div style={{ fontSize:12, color:'#888', marginBottom:16, lineHeight:1.7, padding:'10px 14px', background:'#F5EFE6', borderRadius:8 }}>
            {isAr
              ? 'خلال الأسبوعين الماضيين، كم مرة أزعجتك المشكلات التالية؟'
              : 'Over the last two weeks, how often have you been bothered by the following problems?'}
          </div>
          {PHQ4_QUESTIONS.map((q,qi) => (
            <div key={q.id} style={{ marginBottom:14, padding:'14px 16px', background:qi%2===0?'#FAFAF8':'#fff', borderRadius:10, border:'1px solid #E8E4E0' }}>
              <div style={{ fontSize:14, fontWeight:600, color:'#3D4F5C', marginBottom:12 }}>
                {qi+1}. {isAr?q.ar:q.en}
              </div>
              <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                {PHQ4_OPTIONS.map(opt => {
                  const isSel = phq4[q.id] === opt.value;
                  return (
                    <button key={opt.value} onClick={() => setPhq4(prev => ({ ...prev, [q.id]: opt.value }))}
                      style={{ padding:'8px 14px', border:`2px solid ${isSel?'#5B6DA8':'#E0DDD8'}`, borderRadius:8, background:isSel?'#5B6DA8':'#fff', color:isSel?'#fff':'#555', fontSize:13, fontWeight:isSel?700:400, cursor:'pointer', transition:'all 0.12s' }}>
                      <span style={{ fontWeight:700, marginRight:4 }}>{opt.value}</span> — {isAr?opt.ar:opt.en}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
          {phq4Done && (
            <div style={{ padding:'14px 16px', background:phq4Total>=6?'rgba(192,57,43,0.08)':phq4Total>=3?'rgba(212,147,10,0.08)':'rgba(46,125,107,0.08)', borderRadius:10, border:`1px solid ${phq4Total>=6?'#C0392B':phq4Total>=3?'#D4930A':'#2E7D6B'}44`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <span style={{ fontSize:14, fontWeight:700, color:phq4Total>=6?'#C0392B':phq4Total>=3?'#D4930A':'#2E7D6B' }}>
                {isAr?`المجموع: ${phq4Total}/١٢`:`Total Score: ${phq4Total}/12`}
              </span>
              <span style={{ fontSize:12, color:'#666' }}>
                {phq4Total>=6?(isAr?'قد يشير إلى القلق أو الاكتئاب':'May indicate anxiety/depression'):phq4Total>=3?(isAr?'خفيف إلى معتدل':'Mild to moderate'):(isAr?'طبيعي':'Within normal range')}
              </span>
            </div>
          )}
        </div>

        {error && (
          <div style={{ background:'#FFF0F0', border:'1px solid #F4A8A8', color:'#8A2D2D', padding:'12px 16px', borderRadius:10, fontSize:13, marginBottom:14, textAlign:'center' }}>
            {error}
          </div>
        )}

        <button onClick={handleSubmit} disabled={submitting}
          style={{ width:'100%', padding:'16px', background:submitting?'#aaa':'linear-gradient(135deg, #3D4F5C, #5A6F7D)', color:'#fff', border:'none', borderRadius:12, fontSize:16, fontWeight:700, cursor:submitting?'default':'pointer' }}>
          {submitting?(isAr?'جاري الإرسال...':'Submitting...'):(isAr?'إرسال الإجابات ✓':'Submit Responses ✓')}
        </button>

        <div style={{ textAlign:'center', marginTop:12, fontSize:11, color:'#aaa', lineHeight:1.7 }}>
          {isAr?'إجاباتك سرية وستُرسل إلى الأخصائي الاجتماعي المعني':'Your responses are confidential and will be sent to your assigned social worker'}
        </div>
      </div>
    </div>
  );
}

const ls = {
  label: { display:'block', fontSize:10, fontWeight:700, color:'#555', marginBottom:5, letterSpacing:'0.5px', textTransform:'uppercase' },
  input: { width:'100%', padding:'11px 13px', border:'1.5px solid rgba(200,149,108,0.25)', borderRadius:9, fontSize:14, color:'#2C2C2C', background:'#F5EFE6', outline:'none', boxSizing:'border-box', fontFamily:'Arial,sans-serif' },
};
